import Model from './ModelCustomer'

export default class CustomerUser extends Model {
  resource()
  {
    return 'customer-users'
  }
}